import { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import PWAContext from '../../lib/react-storefront/PWAContext';
import { ErrorBoundary } from 'next/dist/client/components/error-boundary';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      '-webkit-tap-highlight-color': 'transparent'
    },
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'underline'
    }
  }
}));

function PWA({ children, errorReporter }) {
  const router = useRouter();
  useStyles()
  const thumbnail = useRef(null);
  const [offline, setOffline] = useState(typeof navigator !== 'undefined' && !navigator.onLine);
  const context = useMemo(() => ({ thumbnail, offline }), [offline]);

  useEffect(() => {
    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <PWAContext.Provider value={context}>
        <ErrorBoundary onError={errorReporter}>
          {children}
        </ErrorBoundary>
    </PWAContext.Provider>
  );
}

PWA.propTypes = {
  errorReporter: PropTypes.func
};

export default PWA;